import creditsPolicy from "../../functions/stripeSource/creditsPolicy.json";

// TODO(credits): Pull subscription credit amounts dynamically from Stripe metadata.
export const MONTHLY_PRO_CREDITS = Number(creditsPolicy.monthlyProCredits) || 50;
export const ANNUAL_PRO_CREDITS = Number(creditsPolicy.annualProCredits) || 800;
